<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
const moment = require('moment')

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      maximized: false,
      subject: '',
      message: '',
      selected: [],
      students: [],
      allSelected: true,
      pagination: {
        page: 1,
        rowsPerPage: -1,
        descending: true,
        sortBy: "email"
      },
      columns: [
        { name: 'email', required: true, label: 'Email',  field: 'email', sortable: true },
        { name: 'firstName', label: 'First Name', field: 'firstName', sortable: true },
        { name: 'lastName', label: 'Last Name', field: 'lastName', sortable: true },
        { name: 'emailsSent', label: 'Emails Sent', field: 'emailsSent', sortable: true }
      ],
    };
  },
  async created() {
    let vm = this,
        selectedAffiliate = this.sessionInformation.selectedAffiliateObject,
        affiliateText = selectedAffiliate ? `- ${selectedAffiliate.item.AFFILIATE_NAME}` : '',
        meetingLink = this.sessionInformation.meetingLink,
        students = []

    this.sessionInformation.sessions.map(s => {
      let sessionStudents = s.students.map(ss => {
        let emailsSent = ss.emailsSent || 0,
            sid = _.uniqueId('student'),
            selected = (_.trim(ss.email) && emailsSent == 0) 

        if(selected) vm.selected.push({ sid, ...ss })
        
        return {
          ...ss,
          emailsSent,
          selected,
          sid 
        }
      })
      return students.push(...sessionStudents)
    })

    vm.students = students

    vm.subject = `Upcoming Class Meeting Link ${affiliateText}`
    vm.message = `Your Upcoming Distance Learning Class Information:<br /><br />
                  <b>&#128197; Class Dates</b><br /> ${vm.classDatesTable()} <br />
                  <b>&#128279; Meeting Link</b><br /> <a href='${meetingLink}' target="_blank">${meetingLink}</b>                  
                  `
  },
  computed: {
    ...mapState("classes", {
      sessionInformation: s => s.sessionInformation,
      meetingLinkModal : s => s.meetingLinkModal
    }),
    studentTotal(){
      return _.sum(this.sessionInformation.sessions.map(s => {
        let total = 0
        total = _.sum(s.students.map(stu => {
          if(_.trim(stu.email)) return 1
          return 0
        }))
        return total
      }))
    },
    shareLabel(){
      let vm = this,  
          total = vm.selected.length
      return `Email to ${total} Student(s)`
    }
  },
  methods: {
    ...mapActions("classes", [
      "emailClassMeetingLink"
    ]),
    ...mapMutations("classes", [
      "setMeetingLinkModal",
      "updateSelectedStudentCounts"
    ]),
    onSelectAll({ value, props }){
      let vm = this
      console.log(value)
      vm.allSelected = value
      if(value) vm.selected = _.reject(vm.students.map(s => { 
        if(_.trim(s.email)) return { sid: s.sid, ...s }}
      ), _.isNil)
      else {
        vm.selected = []
      }
    },
    onToggleStudentSelect({ value, props }){
      let vm = this, 
          sid = props.row.sid
      props.selected = value
      vm.selected = vm.selected.filter(sel => sel.sid != sid)
      console.log(value)
      if(value){
        vm.selected.push({ sid, ...props.row })
      }
      vm.allSelected = (vm.selected.length == vm.studentTotal)
    },
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    classDatesTable(){
      return `${this.sessionTableRows().join('')}`
    },
    sessionTableRows(){
      return this.sessionInformation.sessions.map(s => {
        let startDate = `${moment(s.startDate).utc().format('MM/DD/YYYY').toString()} @ <i>${s.startHour}:${s.startMin}${s.startPeriod}</i>`,
            endDate = `${moment(s.endDate).utc().format('MM/DD/YYYY').toString()} @ <i>${s.endHour}:${s.endMin}${s.endPeriod}</i>`
        return `${startDate} - ${endDate}<br />`
      })
    },
    studentRowClasses(row){
      let classes = []
      if(!row.email) classes.push('bg-red-2')
      return classes
    },
    async onShareLink(){
      let vm = this,
          { selected, message, subject } = vm
      vm.loading = true
      let response = await vm.emailClassMeetingLink({ selected, message, subject })
      console.log(response)
      if(response && response.data && response.data.success){
        vm.$q.notify({ 
          message: 'Email Sent Successfully.',
          type: 'positive'
        })
        vm.updateSelectedStudentCounts({ selected })
        vm.setMeetingLinkModal(false)
      }
      else{
        vm.$q.notify({ 
          message: 'Failed sending Email.',
          type: 'negative'
        })
      }
      vm.loading = false
    },

  }
};
</script>

<template>
  <q-modal
    id="meetingLinkModal"
    class="sl-modal"
    v-model="meetingLinkModal"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
    :maximized="maximized"
    :content-css="{width: '750px'}"
  >
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title>
          <q-icon name="screen_share"/>
          Share Meeting Link
        </q-toolbar-title>
        <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none"/>
        <q-icon @click.native="setMeetingLinkModal(false)" name="clear"/>
      </q-toolbar>
      
      <div class="sl-row q-pa-md">
        <div class="sl-col-12">
          <h6 class="q-mb-sm q-mt-lg text-uppercase" style="font-size:16px;">Subject</h6>
          <q-input 
            v-model="subject"
          />
        </div>
        <div class="sl-col-12">
          <h6 class="q-mb-sm q-mt-lg text-uppercase" style="font-size:16px;">Message Body</h6>
          <q-editor 
            type="textarea"
            v-model="message"
            float-label="Email Message"
          />
        </div>
        <div class="sl-col-12">
          <q-table
            selection="multiple"
            :data="students"
            id="studentEmailTable"
            :columns="columns"
            row-key="sid"
            :pagination.sync="pagination"
            :selected.sync="selected"
            class="full-width"
            >
            <q-tr slot="header" slot-scope="props">
              <q-th auto-width>
                <q-checkbox
                  v-if="props.multipleSelect"
                  :value="allSelected"
                  @input="value => onSelectAll({ value, props })"
                  indeterminate-value="some"
                />
              </q-th>
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
            <q-tr slot="body" slot-scope="props" :props="props" :class="studentRowClasses(props.row)">
              <q-td auto-width>
                <q-checkbox v-if="_.trim(props.row.email)" color="primary" :value="props.selected" @input="value => onToggleStudentSelect({ value, props })" />
              </q-td>
              <q-td v-for="col in props.cols" :key="col.name" :props="props">
                <span v-if="!_.trim(col.value)" class="text-red"><q-icon name="fa fa-warning" /> Missing</span>
                <span v-else>{{ col.value }}</span>
              </q-td>
            </q-tr>
          </q-table>
        </div>
      </div>
      <q-toolbar slot="footer" class="sl-footer">
        <q-toolbar-title></q-toolbar-title>
        <q-btn style="margin-right:3px;" :disable="selected.length == 0 || loading" color="green" @click="onShareLink()" :label="shareLabel"/>
        <q-btn outline color="faded" @click="setMeetingLinkModal(false)" label="Close"/>
      </q-toolbar>
    </q-modal-layout>
    <q-inner-loading :visible="loading">
      <q-spinner-puff color="primary" size="70"></q-spinner-puff>
      <span v-show="loading">Loading</span>
    </q-inner-loading>
  </q-modal>
</template>

<style lang="stylus">
@import '~variables'
#studentEmailTable
  .q-table-middle
    max-height 300px
</style>
